
    import I18n from 'i18nObj';
    
      import 'translations/sections_tooltip';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('sections_tooltip');
  